import React from 'react';
import { Eye, Sparkles } from 'lucide-react';

type ReleasedAutomaticallyIconProps = {
    size: number;
    'aria-hidden': boolean;
};

/**
 * Results that release automatically: the eye of the results, with sparkles
 * because they appear by themselves when they are ready.
 */
const ReleasedAutomaticallyIcon = ({ size, 'aria-hidden': ariaHidden }: ReleasedAutomaticallyIconProps) => (
    <span className='relative inline-flex' aria-hidden={ariaHidden}>
        <Eye size={size} />
        <Sparkles size={Math.round(size * 0.65)} strokeWidth={2.5} className='absolute -bottom-1 -right-1.5' />
    </span>
);

export default ReleasedAutomaticallyIcon;
